const postMessageToParent = (eventName: string, data = {}): void => {
  window.parent.postMessage({eventName, ...data}, '*')
}

export default postMessageToParent;
